import {useMutation, UseMutationResult} from "react-query";
import {API, CustomAxiosError} from "../../../../logics/api-config";


const useApiDeleteMonthlyInvoice = (): UseMutationResult<void, CustomAxiosError, {
    id: number,
}, unknown> => {
    return useMutation<void, CustomAxiosError, { id: number; }>(
        async ({id}) => {
            try {
                await API.DELETE(`/accounting/bills/monthly/${id}`);
            } catch (error) {
                throw error;
            }
        }
    );
};

export default useApiDeleteMonthlyInvoice;
